define('shared/util/checkout/RedemptionCodeHelper',[
    'shared/util/dispatchers/retrievers/query',
    'shared/lib/RSVP',
    'shared/initializer/form/constants',
    'shared/util/state',
    'shared/remote/payment/redemption/redeem',
    'shared/page/apiVersion'
],
function (queryRetriever, RSVP, constants, state, consumeRedemption, getAPIVersion) {
    'use strict';

    function store(value) {
        return state
            .push(constants.State.RedemptionCode, value);
    }

    function restore() {
        return state
            .get(constants.State.RedemptionCode)
            .then(function(values){
                return values[0];
            });
    }

    function clear() {
        return state
            .push(constants.State.RedemptionCode, null);
    }

    function prioritise(code) {
        return queryRetriever('rcode', {caseSensitive: false})
            .then(function(codeInQueryString) {
                if (codeInQueryString && codeInQueryString.trim() !== ''){
                    return codeInQueryString;
                }
                else if(code){
                    // as discussed with martin, 
                    // redemption component loaded later shall has the priority to be stored
                    return code;
                }
                else {
                    return restore();
                }
            });
    }
    

    function persist(code) {
        return prioritise(code)
            .then(function(finalCode){
                if (!finalCode || finalCode.trim() === '') {
                    return;
                }
                return store(finalCode);
            });
    }

    function Ctor(code) {
        var me = this;
        me.code = code;
        me._promiseReady = persist(me.code);
    }

    /* Retrieve redemption code based on priority */
    Ctor.prototype.retrieve = function() {
        return this._promiseReady
            .then(function(){
                return restore();
            });
    };

    /* Persist highest priority redemption code to state object */
    Ctor.prototype.persist = function(code) {
        var me = this;
        return me._promiseReady
            .then(function(){
                return persist(code || me.code);
            });
    };

    Ctor.prototype.clear = function() {
        var me = this;
        return me._promiseReady
            .then(function(){
                return clear();
            });
    };

    Ctor.prototype.consume = function() {
        var me = this;
        var result;
        return me._promiseReady
            .then(function(){
                return restore();
            })
            .then(function(code){
                if (!code) {
                    return RSVP.resolve(false);
                }
                return getAPIVersion()
                    .then(function(apiVersion){
                        if (apiVersion === 'new-house') {
                            return state.get(constants.State.OrderOfferId);
                        }
                    })
                    .then(function(offers){
                        var params = {
                            rCode: code
                        };
                        if (offers) {
                            params.offers = offers;
                        }
                        return consumeRedemption(params);
                    });
            })
            .then(function(r){
                result = r;
                return clear();
            })
            .then(function(){
                if (result) {
                    return state.push(
                        constants.State.TrackingCheckoutFlowTypeCustom, 
                        constants.CheckoutFlowType.Redemption
                    );
                }
            })
            .then(function(){
                return result;
            });
    };

    return Ctor;
});
